/**
 * Texts for Webinars page
 * 
 * VIDEO URL FORMATS SUPPORTED:
 * 1. YouTube URLs:
 *    - https://www.youtube.com/watch?v=VIDEO_ID
 *    - https://youtu.be/VIDEO_ID
 *    - https://www.youtube.com/embed/VIDEO_ID
 * 
 * 2. Local video files:
 *    - /video/filename.mp4
 *    - Relative or absolute paths to MP4 files
 * 
 * Simply edit the 'videoUrl' field in each video object below.
 * The system automatically detects YouTube links and displays them accordingly.
 */
export const webinarsPageText = {
    title: 'Webinars - CamAPS FX',
    titleMeta: 'CamAPS FX Webinars - Educational video sessions',
    descriptionMeta: 'Watch educational webinars to learn more about using the CamAPS FX app.',
    keywords:
        'camaps fx webinars, camaps tutorials, diabetes app tutorials, insulin pump webinars, cgm webinars, video guides',
    localeMeta: 'en_gb',

    mainHeader: 'Webinars',
    mainSubHeader: 'Learn more about how to use the CamAPS FX app',
    webinarsDisclaimer: 'All webinars are published in English',

    filterAll: 'All',
    filterYpsoPump: 'YpsoPump',
    filterDana: 'Dana',
    sortNewest: 'Newest',
    sortOldest: 'Oldest',
    sortAZ: 'A-Z',
    sortPopular: 'Most popular',

    // Getting Started Section
    virtualModeTooltipText: 'Virtual mode allows you to trial the app without being connected to a real insulin pump and CGM sensor.',
    gettingStartedHeader: 'Ready to get started?',
    step1Title: '<strong>Step 1:</strong> Download the app',
    step2Title: '<strong>Step 2:</strong> Create an account',
    step3Title: '<strong>Step 3:</strong> Begin the in-app essential training',
    step4Title: '<strong>Step 4:</strong> Pair with your chosen pump and CGM (with the approval of your healthcare team) or explore the app with <strong>Virtual Mode</strong>',
    
    // Support Section
    supportSectionTitle: 'Need help installing the app?',
    supportSectionText: 'Visit our support section for guidance.',
    supportButtonText: 'SUPPORT',

    videos: [
        // {
        //     id: 1,
        //     title: 'Introduction to CamAPS FX',
        //     description: 'Learn the basics of CamAPS FX and how it works.',
        //     date: '15 Dec 2024',
        //     duration: '5:24',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 5420
        // },
        // {
        //     id: 2,
        //     title: 'Advanced Pump Settings',
        //     description: 'Explore advanced pump configuration options.',
        //     date: '10 Dec 2024',
        //     duration: '7:15',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 8950
        // },
        // {
        //     id: 3,
        //     title: 'Understanding CGM Integration',
        //     description: 'Learn how to integrate and use CGM data effectively.',
        //     date: '5 Dec 2024',
        //     duration: '4:33',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 12340
        // },
        // {
        //     id: 4,
        //     title: 'Pump Troubleshooting Guide',
        //     description: 'Common issues and solutions for pump connectivity.',
        //     date: '1 Dec 2024',
        //     duration: '6:48',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 3210
        // },
        // {
        //     id: 5,
        //     title: 'Meal Planning with CamAPS FX',
        //     description: 'Best practices for meal-time insulin delivery.',
        //     date: '28 Nov 2024',
        //     duration: '5:12',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 6780
        // },
        // {
        //     id: 6,
        //     title: 'Night Time Management',
        //     description: 'Optimize your settings for better overnight control.',
        //     date: '25 Nov 2024',
        //     duration: '8:05',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 9450
        // },
        // {
        //     id: 7,
        //     title: 'Exercise and Activity Mode',
        //     description: 'Configure settings for physical activity.',
        //     date: '20 Nov 2024',
        //     duration: '3:27',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 4120
        // },
        // {
        //     id: 8,
        //     title: 'Data Analysis and Reports',
        //     description: 'How to interpret and use your glucose data effectively.',
        //     date: '15 Nov 2024',
        //     duration: '4:55',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 7230
        // },
        // {
        //     id: 9,
        //     title: 'Safety Features Overview',
        //     description: 'Understanding safety alarms and alerts in CamAPS FX.',
        //     date: '10 Nov 2024',
        //     duration: '6:18',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 10560
        // },
        // {
        //     id: 10,
        //     title: 'Customization Tips',
        //     description: 'Personalize your CamAPS FX experience.',
        //     date: '5 Nov 2024',
        //     duration: '5:41',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 5890
        // },
        // {
        //     id: 11,
        //     title: 'Bluetooth Connectivity',
        //     description: 'Troubleshooting connection issues with your devices.',
        //     date: '1 Nov 2024',
        //     duration: '7:52',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 8120
        // },
        // {
        //     id: 12,
        //     title: 'Getting the Most from CamAPS FX',
        //     description: 'Advanced tips and tricks for optimal usage.',
        //     date: '28 Oct 2024',
        //     duration: '6:03',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 11230
        // }
        // {
        //     id: 1,
        //     title: 'CamAPS FX Webinar 1: Introducing the CamAPS FX hybrid closed-loop insulin delivery system',
        //     description: 'CamAPS FX Webinar 1: Introducing the CamAPS FX hybrid closed-loop insulin delivery system',
        //     date: '8 Oct 2020',
        //     duration: '46:49',
        //     category: 'ypso',
        //     videoUrl: 'https://youtu.be/m0t_Sc5MEp4',
        //     views: 14000,
        // },
        // {
        //     id: 2,
        //     title: 'CamAPS FX Webinar 2: Starting the App',
        //     description: 'CamAPS FX Webinar 2: Starting the App',
        //     date: '22 Oct 2020',
        //     duration: '40:14',
        //     category: 'ypso',
        //     videoUrl: 'https://youtu.be/H-dKGB08SSM',
        //     views: 13900,
        // },
        // {
        //     id: 3,
        //     title: 'CamAPS FX Webinar 3: Optimising the settings after starting CamAPS FX',
        //     description: 'CamAPS FX Webinar 3: Optimising the settings after starting CamAPS FX',
        //     date: '6 Nov 2020',
        //     duration: '55:09',
        //     category: 'ypso',
        //     videoUrl: 'https://youtu.be/2PUWySDCAbk',
        //     views: 13800,
        // },
        // {
        //     id: 4,
        //     title: 'CamAPS FX Webinar 4: Training for teachers and education support staff',
        //     description: 'CamAPS FX Webinar 4: Training for teachers and education support staff',
        //     date: '20 Nov 2020',
        //     duration: '42:38',
        //     category: 'ypso',
        //     videoUrl: 'https://youtu.be/r7V1V0wVDOQ',
        //     views: 13700,
        // },
        // {
        //     id: 5,
        //     title: 'CamAPS FX Webinar 5: Fine-tuning the system to improve time in range (TIR)',
        //     description: 'CamAPS FX Webinar 5: Fine-tuning the system to improve time in range (TIR)',
        //     date: '7 Dec 2020',
        //     duration: '1:05:25',
        //     category: 'ypso',
        //     videoUrl: 'https://youtu.be/Gwomzu_5udI',
        //     views: 13600,
        // },
        // {
        //     id: 6,
        //     title: 'CamAPS FX Webinar 6: Using the closed-loop insulin delivery system during Pregnancy',
        //     description: 'CamAPS FX Webinar 6: Using the closed-loop insulin delivery system during Pregnancy',
        //     date: '21 Jan 2021',
        //     duration: '54:07',
        //     category: 'ypso',
        //     videoUrl: 'https://youtu.be/pKQArzzv5QA',
        //     views: 13500,
        // },
        // {
        //     id: 7,
        //     title: 'CamAPS FX Webinar 7: Using the closed-loop insulin delivery system in very young children',
        //     description: 'CamAPS FX Webinar 7: Using the closed-loop insulin delivery system in very young children',
        //     date: '17 Feb 2021',
        //     duration: '6:03',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=vUgrVtqksyA',
        //     views: 13400,
        // },
        // {
        //     id: 8,
        //     title: 'CamAPS FX Webinar 8: Using the closed-loop insulin delivery system in Young Adults and Adults',
        //     description: 'CamAPS FX Webinar 8: Using the closed-loop insulin delivery system in Young Adults and Adults',
        //     date: '23 Mar 2021',
        //     duration: '1:12:19',
        //     category: 'ypso',
        //     videoUrl: 'https://youtu.be/KASU0BHAThk',
        //     views: 13300,
        // },
        // {
        //     id: 9,
        //     title: 'CamAPS FX Webinar 9: Managing physical activity, meals & other life events',
        //     description: 'CamAPS FX Webinar 9: Managing physical activity, meals & other life events',
        //     date: '21 Apr 2021',
        //     duration: '1:05:22',
        //     category: 'ypso',
        //     videoUrl: 'https://youtu.be/J0mzjyMxqw0',
        //     views: 13200,
        // },
        // {
        //     id: 10,
        //     title: 'CamAPS FX Webinar 10: Closed-loop insulin therapy and quality of life',
        //     description: 'CamAPS FX Webinar 10: Closed-loop insulin therapy and quality of life',
        //     date: '19 May 2021',
        //     duration: '6:03',
        //     category: 'ypso',
        //     videoUrl: 'https://youtu.be/IwVcDbygQLk',
        //     views: 13100,
        // },
        // {
        //     id: 11,
        //     title: 'CamAPS FX Webinar 11: Closed-loop therapy & long-standing type 1 diabetes',
        //     description: 'CamAPS FX Webinar 11: Closed-loop therapy & long-standing type 1 diabetes',
        //     date: '17 Mar 2021',
        //     duration: '1:02:28',
        //     category: 'ypso',
        //     videoUrl: 'https://youtu.be/fWPA2KPC0bg',
        //     views: 13000,
        // },
        {
            id: 12,
            title: 'Roman Hovorka wins EASD 2023 Award',
            description: 'Roman Hovorka wins EASD 2023 Award',
            date: '27 Sep 2023',
            duration: '9:57',
            category: 'ypso',
            videoUrl: 'https://www.youtube.com/watch?v=4PPuVNGmxFU',
            views: 12900,
        },
        {
            id: 13,
            title: 'Hybrid Closed-Loop (HCL) Therapy for People with Type 1 Diabetes who are Pregnant - NHS England',
            description: 'Hybrid Closed-Loop (HCL) Therapy for People with Type 1 Diabetes who are Pregnant - NHS England',
            date: '8 Oct 2024',
            duration: '1:30:00',
            category: 'ypso',
            videoUrl: 'https://youtu.be/wsdIWw5XPeE',
            views: 12800,
        },
        {
            id: 14,
            title: 'Managing Pregnancy using the CamAPS FX HCL system Webinar',
            description: 'Managing Pregnancy using the CamAPS FX HCL system Webinar',
            date: '20 Jan 2021',
            duration: '1:27:12',
            category: 'ypso',
            videoUrl: 'https://youtu.be/_y15xt6zUao',
            views: 12700,
        },
        {
            id: 15,
            title: 'CamAPS FX catch up with Helen Murphy, Professor of Medicine (Diabetes and Antenatal Care), UK',
            description: 'CamAPS FX catch up with Helen Murphy, Professor of Medicine (Diabetes and Antenatal Care), UK',
            date: '22 Apr 2026',
            duration: '7:24',
            category: 'ypso',
            thumbnail: '/images/helen.jpg',
            videoUrl: 'https://youtu.be/arJbSlkJ4HU',
            views: 14500,
        },
        {
            id: 16,
            title: 'Introducing CamAPS Liberty',
            description: 'Introducing CamAPS Liberty',
            date: '28 Jul 2026',
            duration: '14:42',
            category: 'ypso',
            thumbnail: '/images/introducing-camaps-liberty.png',
            videoUrl: 'https://youtu.be/K7_j-Sk5Fas',
            views: 14600,
        },
        {
            id: 17,
            title: 'CamAPS Liberty: Getting started',
            description: 'CamAPS Liberty: Getting started',
            date: '15 Sep 2026',
            duration: '31:50',
            category: 'ypso',
            videoUrl: 'https://youtu.be/px9QSOhy544',
            views: 14700,
        }
    ]
};

